// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"133":"af915400","272":"27359e0e"}[chunkId] + ".css";
};